import { lato, nunito_sans } from '@styles/fonts'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    maxWidth: '1081px',
    margin: 'auto',
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '72px',
    fontWeight: 800,
    lineHeight: '83px',
    textAlign: 'center',
    marginBottom: theme.spacing(7),
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {
      fontSize: '50px',
      lineHeight: '53.65px',
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px',
      lineHeight: '43.65px',
      marginBottom: theme.spacing(4),
    },
  },
  text: {
    fontFamily: lato.style.fontFamily,
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: ' 24px',
    textAlign: 'center',
    p: {
      padding: 0,
      margin: '12px 0',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '16.8px',
    },
  },
}))

export default useStyles
